$(document).ready(function () {
  $('.owl-carousel').owlCarousel({
    nav: false,
      dots: true,
      loop: true,
      items: 1,
      autoplay: true,
      autoplaySpeed: 3000,
      lazyLoad: true,
      animateOut: 'fadeOut'
  });
});